import { actionCreatorFactory } from 'typescript-fsa'
import { AppConfig } from '../../types'

const actionCreator = actionCreatorFactory()

export const updateConfig = actionCreator<Partial<AppConfig>>('updateConfig')
